/* @flow */

import React from 'react';

type Props = {
  source: string,
};

const TextToken = ({source}: Props) => <span>{source}</span>;

export default TextToken;



// WEBPACK FOOTER //
// ../src/client/components/UserText/TextToken.js